(function () {
  function qs(root, selector) {
    return root.querySelector(selector);
  }

  function qsa(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function getUrlParam(param) {
    if (!param) return '';
    try {
      var url = new URL(window.location.href);
      return (url.searchParams.get(param) || '').trim();
    } catch (_) {
      return '';
    }
  }

  function setUrlParam(param, value) {
    if (!param) return;
    try {
      var url = new URL(window.location.href);
      url.searchParams.set(param, value);
      window.history.replaceState({}, '', url.toString());
    } catch (_) {}
  }

  function positionTabDot(root) {
    var tabsWrap = qs(root, '.fabric-tabs');
    if (!tabsWrap) return;

    var activeTab = qs(tabsWrap, '[data-tab-handle].is-active');
    if (!activeTab) return;

    var tabRect = activeTab.getBoundingClientRect();
    var wrapRect = tabsWrap.getBoundingClientRect();
    var dot = qs(tabsWrap, '[data-tab-dot]');

    if (dot) {
      var x = (tabRect.left - wrapRect.left) + (tabRect.width / 2) - (dot.offsetWidth / 2);
      var y = (tabRect.bottom - wrapRect.top) + 6;

      dot.style.setProperty('--fabric-dot-x', x + 'px');
      dot.style.setProperty('--fabric-dot-y', y + 'px');
      dot.classList.add('is-visible');
    }

  }

  function scheduleDotPosition(root) {
    if (!window.requestAnimationFrame) {
      positionTabDot(root);
      return;
    }

    window.requestAnimationFrame(function () {
      positionTabDot(root);
    });
  }

  function activate(root, handle, focusPanel) {
    var tabs = qsa(root, '[data-tab-handle]');
    var panels = qsa(root, '[data-tab-panel]');

    var tab = tabs.find(function (t) {
      return t.getAttribute('data-tab-handle') === handle;
    });

    var panel = panels.find(function (p) {
      return p.getAttribute('data-tab-panel') === handle;
    });

    if (!tab || !panel) return;

    tabs.forEach(function (t) {
      var active = t === tab;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
      t.tabIndex = active ? 0 : -1;
    });

    panels.forEach(function (p) {
      var active = p === panel;
      p.classList.toggle('is-active', active);
      p.hidden = !active;
    });

    scheduleDotPosition(root);
    setUrlParam(root.getAttribute('data-tabs-param'), handle);

    if (focusPanel) {
      panel.focus({ preventScroll: false });
    }

    try {
      root.dispatchEvent(new CustomEvent('tabswitcher:change', {
        bubbles: true,
        detail: { handle: handle }
      }));
    } catch (_) {}
  }

  function initOne(root) {
    if (!root || root.__tabsSwitcherInit) return;
    root.__tabsSwitcherInit = true;

    var tabs = qsa(root, '[data-tab-handle]');
    if (!tabs.length) return;

    var initial = getUrlParam(root.getAttribute('data-tabs-param'));
    var activeFromMarkup = tabs.find(function (t) {
      return t.classList.contains('is-active') || t.getAttribute('aria-selected') === 'true';
    });
    var fallback = activeFromMarkup || tabs[0];
    var initialHandle = initial || fallback.getAttribute('data-tab-handle');

    activate(root, initialHandle, false);

    root.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('[data-tab-handle]');
      if (!button || !root.contains(button)) return;
      activate(root, button.getAttribute('data-tab-handle'), false);
    });

    root.addEventListener('keydown', function (event) {
      var activeTab = event.target && event.target.closest && event.target.closest('[data-tab-handle]');
      if (!activeTab || !root.contains(activeTab)) return;

      var localTabs = qsa(root, '[data-tab-handle]');
      var index = localTabs.indexOf(activeTab);
      if (index < 0) return;

      var nextIndex = -1;
      if (event.key === 'ArrowRight') nextIndex = (index + 1) % localTabs.length;
      else if (event.key === 'ArrowLeft') nextIndex = (index - 1 + localTabs.length) % localTabs.length;
      else if (event.key === 'Home') nextIndex = 0;
      else if (event.key === 'End') nextIndex = localTabs.length - 1;
      else if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        activate(root, activeTab.getAttribute('data-tab-handle'), true);
        return;
      } else {
        return;
      }

      event.preventDefault();
      localTabs[nextIndex].focus();
      activate(root, localTabs[nextIndex].getAttribute('data-tab-handle'), false);
    });

    window.addEventListener('resize', function () {
      scheduleDotPosition(root);
    }, { passive: true });
  }

  function boot(scope) {
    qsa(scope || document, '[data-tabs-switcher]').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;

    if (event.target.matches && event.target.matches('[data-tabs-switcher]')) {
      event.target.__tabsSwitcherInit = false;
      initOne(event.target);
      return;
    }

    boot(event.target);
  });
})();
